const loadScript = (src: string) =>
  new Promise<void>((resolve) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = () => resolve()
    document.head.appendChild(script)
  })

export default new Promise((resolve) => {
  /*
   * The `drawing` library (DrawingManager) was removed in Maps JS API v3.65. We replace it with
   * the vendored mcx-drawing-polyfill, which re-implements google.maps.drawing on top of native
   * overlays. The polyfill must load after the Maps API and before any component reads
   * google.maps.drawing, so we chain-load it (core, then the circle/rectangle extension) and only
   * resolve once both are applied. See frontend/public/vendor/mcx-drawing/README.md
   */
  const googleURL = `https://maps.googleapis.com/maps/api/js?key=${
    import.meta.env.VITE_GOOGLE_API_KEY
  }&libraries=places,geometry,maps`
  void loadScript(googleURL)
    .then(() => loadScript('/vendor/mcx-drawing/mcx-drawing-polyfill.js'))
    .then(() => loadScript('/vendor/mcx-drawing/mcx-drawing-shapes.js'))
    .then(() => resolve(window['google']))
})
